import {NavLink} from 'react-router-dom';
import React, { useContext } from 'react';
import { useLocation } from "react-router-dom";


import { listaSeccionesStyle } from './../styles/general';
import SeccionesContext from './../context/seccionesContext';

function ListaSecciones({ onItemClick }) {
    const location = useLocation();
    const cod = location.pathname.split('/').at(-1);

    const { secciones: seccionesTodas, onCambiarVisibilidadSeccion } = useContext(SeccionesContext);
    function handleClickIrToSeccion(){
        onItemClick();
    }
    function handleClickMostrarSubSecciones(seccion){
        onCambiarVisibilidadSeccion(seccion);
    }
    function renderItemSeccion(seccion, indent){
        const conSubsecciones = seccion.secciones && seccion.secciones.length > 0 ? true : false;
        // const classArrow = "arrowLink " + "fa fa-chevron-circle-" + (conSubsecciones && seccion.secciones[0].visible ? "left" : "right");
        const classArrow = "arrowLink fa fa-arrow-circle-" + (conSubsecciones && seccion.secciones[0].visible ? "up" : "down");
        const styleLink = {marginLeft: indent + "px", display: "inline-block"};
        // if (cod === seccion.codigo) {
        //     styleLink.textShadow = "1px 1px 10px #fff, 1px 1px 10px #ccc";
        // }
        return(
            <li key={seccion.codigo} style={{ display: seccion.visible ? "block" : "none" }}>
                <div title={seccion.titulo} onClick={conSubsecciones ? (() => handleClickMostrarSubSecciones(seccion)) : handleClickIrToSeccion} style={{ display: "inline-block" }}>
                {conSubsecciones 
                    ? 
                        <div>
                            <span style={styleLink} className='linkSpanStyle'>{seccion.titulo}</span>  
                            {'\u00A0\u00A0'}
                            <i className={classArrow} aria-hidden="true"></i>
                        </div>
                    : 
                        <div>
                            <NavLink style={styleLink} to={seccion.codigo}>{seccion.titulo}</NavLink>
                            <span>{cod === seccion.codigo ? <i style={{paddingLeft: "5px"}} className="fa fa-hand-o-left" aria-hidden="true"></i> : null}</span>
                        </div>
                }
                </div>
            </li>
        )
    }
    function renderSeccion(secciones, indent, seccion = null){
        return(
            <ul key={(seccion ? seccion.codigo : "base") + "_ul"} style={listaSeccionesStyle}>
                {
                    secciones.map(x => {
                        let renderItemSeccionAux = renderItemSeccion(x, indent);
                        if (x.secciones && x.secciones.length > 0){
                            renderItemSeccionAux = [renderItemSeccionAux].concat(renderSeccion(x.secciones, indent + 10, x));
                        }
                        return renderItemSeccionAux;
                    })
                }
            </ul>
        )
    }
    if (seccionesTodas && seccionesTodas.length > 0){
        return renderSeccion(seccionesTodas, 0);
    } else {
        return <div className='avisoProcesando blink20' style={{paddingTop: "8px"}}>Cargando...</div>;
    }
}

export default ListaSecciones;
